import { ERROR_MESSAGE } from "../constants";

interface ValidationResult {
  formValid: boolean;
  formErrors: Record<string, string>;
}

// Rating-question form (contracts #8/#9). `questionText` is required and
// `displayOrder` must be provided.
export const feedbackQuestionValidation = (data: {
  questionText: string;
  displayOrder?: number | string;
}): ValidationResult => {
  const formErrors: Record<string, string> = {};
  let formValid = true;

  if (!data.questionText || !data.questionText.trim()) {
    formValid = false;
    formErrors.questionText = ERROR_MESSAGE.QUESTION_TEXT_REQUIRED;
  }

  return { formValid, formErrors };
};

// Comment-field form (contracts #12/#13). `fieldLabel` is required and
// `characterLimit` must be a positive number.
export const feedbackCommentFieldValidation = (data: {
  fieldLabel: string;
  characterLimit: number | string;
}): ValidationResult => {
  const formErrors: Record<string, string> = {};
  let formValid = true;

  if (!data.fieldLabel || !data.fieldLabel.trim()) {
    formValid = false;
    formErrors.fieldLabel = ERROR_MESSAGE.FIELD_LABEL_REQUIRED;
  }

  if (
    data.characterLimit === "" ||
    data.characterLimit === null ||
    data.characterLimit === undefined
  ) {
    formValid = false;
    formErrors.characterLimit = ERROR_MESSAGE.CHARACTER_LIMIT_REQUIRED;
  } else if (Number(data.characterLimit) <= 0) {
    formValid = false;
    formErrors.characterLimit = ERROR_MESSAGE.CHARACTER_LIMIT_POSITIVE;
  }

  return { formValid, formErrors };
};
